import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';

import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { SetFormatComponent } from './set-format/set-format.component';
import { Subject, from } from 'rxjs';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from 'src/app/services/common.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-c-code',
  templateUrl: './c-code.component.html',
  styleUrls: ['./c-code.component.scss']
})
export class CCodeComponent implements OnInit {
  columnDefs;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  modules: any;
  collapesedOrNot: boolean;
  codeForm = new UntypedFormGroup({
    MODULE_ID: new UntypedFormControl(""),
    FEATURENAME: new UntypedFormControl(""),
    Status: new UntypedFormControl("-1")
  });

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.collapesedOrNot = false;
    this.columnDefs = [
      {
        "headerName": "Program",
        "field": "ModuleName",
      },
      {
        "headerName": "Feature",
        "field": "FeatureName"
      },
      /*  {
         "headerName": "Enabled",
         "field": "Enabled"
       }, */
      {
        "headerName": "Format",
        "field": "CodeFormat"
      }
      //,
      //{
      //  "headerName": "Status",
      //  "field": "Status"
      //}

    ];
    this.advanceSearch = {
      "fields": [
        {
          "label": "Module Name",
          "field": "ModuleName",
          "type": "text"
        },
        {
          "label": "Feature Name",
          "field": "FeatureName",
          "type": "dropdown"
        },
        {
          "label": "Enabled",
          "field": "Enabled",
          "type": "dropdown",
          "options": [
            { "value": "Yes", "label": "Yes." },
            { "value": "No", "label": "No." }
          ]
        }
      ]
    };
    this.operations = [];
    if (this.commonService.getScreenPermission("620", "E")) {
      this.operations.push({
        "name": "Edit",
        "id": "Edit"
      });
    }
    this.operations = this.operations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    this.setSummary();
    this.getModules();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  getModules() {
    this.summaryService.getModuleByOrgId('api/common/getautocodemodules').subscribe((result) => {
      this.modules = result;
    });
  }


  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }


  Edit() {
    //debugger;
    let modalRef = this['self'].modalService.open(SetFormatComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });

    modalRef.componentInstance.Content =
    {
      // heading: 'Add',p
      // content:

      id: this['self'].selectedRow['ID'],
      program: this['self'].selectedRow['ModuleName'],
      feature: this['self'].selectedRow['FeatureName']
    }
    modalRef.result.then((result) => {
      this['self'].setSummary();
    });
  }


  delete() {
    const modalRef = this["self"].modalService.open(DeleteBoxComponent,{backdrop: false});
  };

  setSummary() {
    this.summaryService.getCCodeSummary().subscribe(summary => {
      this.rowData = summary
    });
  }
  setSearchSummary(formData) {
    this.summaryService.getAutoCodeSearchSummary(formData).subscribe(summary => {
      this.rowData = summary;
    });
  }

  setSearch() {
    this.SearchClear();
    this.summaryService.getAutoCodeSearchSummary(this.codeForm.value).subscribe(summary => {
      this.rowData = summary;
    });
  }

  //// Advace search Functions
  SearchClear() {
    this.codeForm = new UntypedFormGroup({
      MODULE_ID: new UntypedFormControl(""),
      FEATURENAME: new UntypedFormControl("")
      //  Status: new FormControl("-1")
    });
  }

  AdvanceSearch() {
    this.setSearchSummary(this.codeForm.value);
  }

}

